/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from "./Effect";

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** Effect for snapping a group of nodes to a new position. */
@ccclass
export default class SetNodePositionEffect extends Effect
{
    /** Position which the nodes should be moved to. */
    @property({ visible: true })
    private _position: cc.Vec2 = new cc.Vec2();

    /** The group of nodes to be moved. */
    @property({ type: [cc.Node], visible: true })
    private _nodes: cc.Node[] = [];

    /** Executes the assigning of the new position to the referenced node group. */
    protected trigger = (): void =>
    {
        this._nodes.forEach((x) => x.position = this._position, this);
        this.complete();
    }
}
